// src/assets/data/courses.js

// importa aquí tus assets
import banner1_es from "../courses/finanzas.webp";
import banner1_pt from "../courses/finanzaspt.png";
import banner2_es from "../courses/presupuesto-ahorro.webp";
import banner2_pt from "../courses/presupuesto-ahorropt.png";
// … importa tantas como necesites

export const courses = [
  {
    id: "finanzas-personales",
    title: "Finanzas Personales para Jóvenes Mexicanos",
    rating: 5,
    description:
      "Aprende a manejar tu dinero de forma consciente, sin necesidad de experiencia previa en finanzas.",
    level: "Principiante",
    duration: "12 hs",
    banners: {
      es: banner1_es,
      pt: banner1_pt,
    },
  },
  {
    id: "cripto-blockchain",
    title: "Introducción al Mundo Cripto y Blockchain",
    rating: 5,
    description:
      "Curso práctico e interactivo sobre Web3, cripto y blockchain pensado para Gen Z.",
    level: "Principiante",
    duration: "10 hs",
    banners: {
      es: banner2_es,
      pt: banner2_pt,
    },
  },
  // … más cursos
];
